<template>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./dashboard/AppBar'),
      DashboardCoreDrawer: () => import('./dashboard/DrawerNew'),
      DashboardCoreView: () => import('./dashboard/DashboardView'),
    },

    data: () => ({
      expandOnHover: true,
    }),
  }
</script>

<style scoped>
.theme--light .v-content {
  background-color: #FEFBFB;
}
</style>
